import { Form, Input } from "antd"
import React from "react"

interface SectionHeaderBlockProps {
  fieldKey: string
}

export function SectionHeaderBlock({ fieldKey }: SectionHeaderBlockProps) {
  return (
    <Form.Item
      name={["block_data", fieldKey, "title"]}
      label="Title"
      rules={[
        { required: true, whitespace: true, message: "Title is required" }
      ]}
    >
      <Input placeholder={"Enter title"} />
    </Form.Item>
  )
}
